import '@descope-ui/descope-list';
import '@descope-ui/descope-avatar';
import '@descope-ui/descope-text';
import { componentName, AppsListClass } from './AppsListClass';

customElements.define(componentName, AppsListClass);

export { AppsListClass, componentName };
